import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private activeRequests = 0;

  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // If request explicitly skips loader, bypass LoaderService completely
    if (req.headers.has('skip-loader') || req.headers.has('x-skip-loader')) {
      const cleanReq = req.clone({
        headers: req.headers.delete('skip-loader').delete('x-skip-loader')
      });
      return next.handle(cleanReq);
    }

    if (this.activeRequests === 0) {
      this.loaderService.show();
    }
    this.activeRequests++;

    return next.handle(req).pipe(
      finalize(() => {
        this.activeRequests--;
        if (this.activeRequests === 0) {
          this.loaderService.hide();
        }
      })
    );
  }
}